import {Avatar, Icon, Menu, Spin, Tag, notification, Modal, Button} from 'antd'
import {push} from 'connected-react-router'
import groupBy from 'lodash/groupBy'
import moment from 'moment'
import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import {CheckUserRight} from '../../containers/dashboard/views/DashboardUserWise'
import {
    loadNotificationCountFxn,
    resetNotificationCountFxn,
    resetPrivateMessageCountFxn
} from '../../containers/users/actions/user'
import { getUrlPushWrapper } from '../../routes/routes'
import HeaderDropdown from '../HeaderDropdown'
import NoticeIcon from '../NoticeIcon'
import PrivateMessageIcon from '../PrivateMessage'
import PromotionIcon from '../PromotionIcon'
import LatestUpdateIcon from '../LatestUpdateIcon'
import styles from './index.less'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import {departmentObj, gicCommissionValue} from '../_utils/appUtils'
import {downloadAgentProfileFxn, downloadAgentProfileOtpFxn} from '../../containers/latestUpdate/actions'
import InputBox from '../_utils/InputBox'
import DownloadProfile from "../commonComponents/downloadProfile";

const blankAvatar = `data:image/png;base64,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`
let uuid = ''

class GlobalHeaderRight extends PureComponent {
    state = {
        noOfNotification: 0,
        noOfMessage: 0,
        notificationData: [],
        privateMessageData: [],
        whatsNewVisible: false
    }

    constructor() {
        super()
        this.getNoOfNotification()
    }


    componentWillMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let {reloadNotification, reloadPrivateMessage, socketData} = nextProps
        if (reloadNotification) {
            this.loadNoOfNotification(socketData)
        }
        if (reloadPrivateMessage) {
            this.loadNoOfPrivateMessage(socketData)
        }
    }

    getNoticeData() {
        const {notices = []} = this.props
        if (notices.length === 0) {
            return {}
        }
        const newNotices = notices.map(notice => {
            const newNotice = {...notice}
            if (newNotice.datetime) {
                newNotice.datetime = moment(notice.datetime).fromNow()
            }
            if (newNotice.id) {
                newNotice.key = newNotice.id
            }
            if (newNotice.extra && newNotice.status) {
                const color = {
                    todo: '',
                    processing: 'blue',
                    urgent: 'red',
                    doing: 'gold'
                }[newNotice.status]
                newNotice.extra = (
                    <Tag color={color} style={{marginRight: 0}}>
                        {newNotice.extra}
                    </Tag>
                )
            }
            return newNotice
        })
        return groupBy(newNotices, 'type')
    }

    loadNoOfNotification(data) {
        const {dispatch} = this.props
        let user = localStorage.getItem('user')
            ? JSON.parse(localStorage.getItem('user'))
            : null
        if (data && data.userId == user._id) {
            this.setState({
                noOfNotification: data.noOfNotification
            })
            notification.success({
                message: `You have new notification.`,
                description: data.obj.message,
                placement: 'bottomRight'
            })
            dispatch({
                type: 'RELOAD_NOTIFICATION',
                value: false,
                socketData: {}
            })
        }
    }

    loadNoOfPrivateMessage(data) {
        const {dispatch} = this.props
        let user = localStorage.getItem('user')
            ? JSON.parse(localStorage.getItem('user'))
            : null
        if (data && data.userId == user._id) {
            this.setState({
                noOfMessage: data.noOfMessage
            })
            notification.success({
                message: `You have new private message.`,
                description: data.obj.message,
                placement: 'bottomRight'
            })
            dispatch({
                type: 'PRIVATE_MESSAGE',
                value: false,
                socketData: {}
            })
        }
    }

    async getNoOfNotification() {
        let {
            noOfNotification,
            success,
            noOfMessage
        } = await loadNotificationCountFxn()
        if (success) {
            this.setState({
                noOfNotification: noOfNotification ? noOfNotification : 0,
                noOfMessage: noOfMessage ? noOfMessage : 0
            })
        }
    }

    async resetUserNotification() {
        let {noOfNotification, success, data} = await resetNotificationCountFxn()
        if (success) {
            this.setState({
                noOfNotification: 0,
                notificationData: data
            })
        }
    }

    async resetUserPrivateMessage() {
        let {
            noOfNotification,
            success,
            data
        } = await resetPrivateMessageCountFxn()
        if (success) {
            this.setState({
                noOfMessage: 0,
                privateMessageData: data
            })
        }
    }

    getUnreadData = noticeData => {
        const unreadMsg = {}
        Object.entries(noticeData).forEach(([key, value]) => {
            if (!unreadMsg[key]) {
                unreadMsg[key] = 0
            }
            if (Array.isArray(value)) {
                unreadMsg[key] = value.filter(item => !item.read).length
            }
        })
        return unreadMsg
    }

    changeReadState = async clickedItem => {
        const {applicationId, studentId} = clickedItem
        // let resp = await notificationReadyFxn(_id)
        let user = localStorage.getItem('user')
            ? JSON.parse(localStorage.getItem('user'))
            : null
        if (user) {
            if (
                user.userType == 'admin' ||
                user.userType == 'branchManager' ||
                (user.userType == 'branchUser' && user.department !== departmentObj.assDepartment)
            ) {
                let url = `/student/application?studentId=${studentId}&appId=${applicationId}`
                window.open(url, '_blank')
            } else {
                this.props.dispatch(
                    getUrlPushWrapper('application.singleApplication', {
                        studentId: studentId,
                        appId: applicationId
                    })
                )
            }
            this.getNoOfNotification()
        }
    }

    goToPage = key => {
        const {dispatch, currentUser} = this.props
        window.scrollTo(0, 0)
        switch (key) {
            case 'company':
                dispatch(push('/company/all'))
                break
            case 'withdrawals':
                dispatch(push('/withdrawal'))
                break
            case 'feedback':
                dispatch(push('/feedback/all'))
                break
            case 'newsEnquiry':
                dispatch(push('/news-enquiry'))
                break
            case 'scheduleMeeting':
                dispatch(push('/scheduleMeeting/all'))
                break
            case 'commission':
                dispatch(push('/all-commission'))
                break
            case 'dailyLeads':
                dispatch(push('/daily-leads'))
                break
            case 'agentCommission':
                dispatch(push('/agent-commission'))
                break
            case 'agentProfile':
                dispatch(push('/agent-profile'))
                break
            case 'userProfile':
                dispatch(push('/user-profile'))
                break
            case 'trainingRequest':
                window.open(`/trainingRequest/${currentUser._id}`)
                break
            case 'studentProfile':
                dispatch(push(`/student-profile`))
                break
            case 'studentWithdrawal':
                dispatch(push(`/student-withdrawal`))
                break
            case 'addComplaint':
                dispatch(push(`/raise-a-complaint`))
                break
            case 'addGic':
                dispatch(push(`/gic/add-gic`))
                break
            case 'updateForexMargin':
                dispatch(push('/update-forex-margin'))
                break
            case 'updateExchangeMargin':
                dispatch(push('/update-exchange-margin'))
                break
            case 'updateXTravelWorldMargin':
                dispatch(push('/update-xtravelworld-margin'))
                break
            case 'updateXTravelWorldExchangeMargin':
                dispatch(push('/update-xtravelworld-exchange-margin'))
                break
            default:
                console.log(key, ' this is working')
        }
    }

    getDisplayName = currentUser => {
        if (currentUser.userType) {
            if (currentUser.userType == 'agent') {
                return 'Partner'
            } else if (currentUser.userType == 'subAgent') {
                return 'Partner Team'
            } else if (currentUser.userType == 'student') {
                return currentUser.name
            } else {
                if (currentUser.postName) {
                    return currentUser.postName
                } else {
                    return currentUser.userType
                }
            }
        } else {
            return 'User'
        }
    }


    render() {
        const {
            currentUser,
            fetchingNotices,
            onNoticeVisibleChange,
            onMessageVisibleChange,
            showAllPrivateMessage,
            showAllNotice,
            onMenuClick,
            onNoticeClear,
            theme,
            currentUserRights
        } = this.props
        const menu = (
            <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
                <CheckUserRight
                    user={currentUser}
                    rightUserType={['admin', 'branchManager', 'branchUser', 'reeudoManager']}>
                    <Menu.Item
                        key='userProfile'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('userProfile')}>
                        <Icon type={'user'} style={{fontSize: '14px'}}/>
                        <span>My Profile</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight
                    user={currentUser}
                    rightUserType={['student']}>
                    <Menu.Item
                        key='studentProfile'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('studentProfile')}>
                        <Icon type={'user'} style={{fontSize: '14px'}}/>
                        <span>My Profile</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['admin']}>
                    <Menu.Item
                        key='company'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('company')}>
                        <LazyLoadImage
                            src={'../dist/icons/building.png'}
                            className={styles.iconBox}
                        />
                        <span>Company</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['agent']}>
                    <Menu.Item
                        key='agentProfile'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('agentProfile')}>
                        {/*<LazyLoadImage src={'../btnImgs/user.png'} className={styles.iconBox} />*/}
                        <Icon type={'user'} style={{fontSize: '14px'}}/>
                        <span>My Profile</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['agent']}>
                    <Menu.Item
                        key='downloadProfile'
                        className={'ant-dropdown-menu-item'}>
                        <DownloadProfile>
                            <Icon type={'cloud-download'} style={{fontSize: '14px'}}/>
                            <span>Download Your Profile</span>
                        </DownloadProfile>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight
                    user={currentUser}
                    rightUserType={['admin', 'agent', 'subAgent']}>
                    <Menu.Item
                        key='withdrawals'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('withdrawals')}>
                        <LazyLoadImage
                            src={'../dist/icons/withdrawal.png'}
                            className={styles.iconBox}
                        />
                        <span>Withdrawals</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight
                    user={currentUser}
                    rightUserType={['student']}>
                    <Menu.Item
                        key='studentWithdrawal'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('studentWithdrawal')}>
                        <LazyLoadImage
                            src={'../dist/icons/withdrawal.png'}
                            className={styles.iconBox}
                        />
                        <span>Your Withdrawals</span>
                    </Menu.Item>
                </CheckUserRight>
                {/* <CheckUserRight user={currentUser} rightUserType={['admin', 'branchManager', 'branchUser']}>
          <Menu.Item key="feedback" className={'ant-dropdown-menu-item'}
                     onClick={() => this.goToPage('feedback')}>
            <LazyLoadImage src={'../dist/icons/feedback.png'} className={styles.iconBox}/>
            <span>Feedback & Complaints</span>
          </Menu.Item>
        </CheckUserRight>*/}
                <CheckUserRight user={currentUser} rightUserType={['agent']}>
                    <Menu.Item
                        key='feedback'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('trainingRequest')}>
                        <LazyLoadImage
                            src={'../dist/icons/feedback.png'}
                            className={styles.iconBox}
                        />
                        <span>Request for portal training</span>
                    </Menu.Item>

                    <Menu.Item
                        key='addGic'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('addGic')}>
                        <LazyLoadImage
                            src={'../dist/icons/diploma.png'}
                            className={styles.iconBox}
                        />
                        <span>Open Gic Acc - Get {gicCommissionValue}</span>
                    </Menu.Item>

                    {/* <Menu.Item
                    key='feedback'
                    className={'ant-dropdown-menu-item'}
                    onClick={() => this.goToPage('addComplaint')}>
                    <LazyLoadImage src={'../dist/icons/feedback.png'} className={styles.iconBox} />
                    <span>Raise A Complaint</span>
                  </Menu.Item>*/}
                </CheckUserRight>


                <CheckUserRight
                    user={currentUser}
                    rightUserType={[
                        'admin',
                        'branchManager',
                        'branchUser',
                        'agent',
                        'subAgent'
                    ]}>
                    <Menu.Item
                        key='feedback'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('scheduleMeeting')}>
                        <LazyLoadImage src={'../dist/icons/comment.png'} className={styles.iconBox}/>
                        <span>Meeting</span>
                    </Menu.Item>
                </CheckUserRight>
                <CheckUserRight
                    user={currentUser}
                    rightUserType={[
                        'agent'
                    ]}>
                    <Menu.Item
                        key='feedback'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('addComplaint')}>
                        <LazyLoadImage src={'../dist/icons/comment.png'} className={styles.iconBox}/>
                        <span>Raise A Complaint</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['agent']}>
                    <Menu.Item
                        key='updateForexMargin'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('updateForexMargin')}>
                        <LazyLoadImage
                            src={'../dist/icons/feedback.png'}
                            className={styles.iconBox}
                        />
                        <span>Update Forex Margin</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['admin']}>
                    <Menu.Item
                        key='updateExchangeMargin'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('updateExchangeMargin')}>
                        <LazyLoadImage
                            src={'../dist/icons/feedback.png'}
                            className={styles.iconBox}
                        />
                        <span>Update Exchange Margin</span>
                    </Menu.Item>
                </CheckUserRight>

                <CheckUserRight user={currentUser} rightUserType={['admin']}>
                    <Menu.Item
                        key='updateXTravelWorldExchangeMargin'
                        className={'ant-dropdown-menu-item'}
                        onClick={() => this.goToPage('updateXTravelWorldExchangeMargin')}>
                        <LazyLoadImage
                            src={'../dist/icons/feedback.png'}
                            className={styles.iconBox}
                        />
                        <span>Update Your XTravelWorld Margin</span>
                    </Menu.Item>
                    <Menu.Item
                      key='updateXTravelWorldMargin'
                      className={'ant-dropdown-menu-item'}
                      onClick={() => this.goToPage('updateXTravelWorldMargin')}>
                        <LazyLoadImage
                          src={'../dist/icons/feedback.png'}
                          className={styles.iconBox}
                        />
                        <span>Update Agent's XTravelWorld Margin</span>
                    </Menu.Item>

                </CheckUserRight>
                {currentUserRights && currentUserRights.allowLeads ? (
                    <Menu.Item
                        key='dailyLeads'
                        onClick={() => this.goToPage('dailyLeads')}>
                        <Icon type='line-chart'/>
                        <span>Daily Leads</span>
                    </Menu.Item>
                ) : null}
                <Menu.Item key='changePassword'>
                    <Icon type='key'/>
                    <span>Change Password</span>
                </Menu.Item>
                <Menu.Item key='logout'>
                    <Icon type='logout'/>
                    <span>logout</span>
                </Menu.Item>
            </Menu>
        )
        // const noticeData = this.getNoticeData()
        // const unreadMsg = this.getUnreadData(noticeData)
        let className = styles.right

        if (theme === 'dark') {
            className = `${styles.right}  ${styles.dark}`
        }
        return (
            <div className={className}>
                {/*  {currentUser &&
                currentUser.userType == 'student' &&
                currentUser.countryISOCode == 'CA_+1' ? (
                    <span className={'referBtn'}>
            <a
                className={'ant-badge'}
                onClick={() => {
                    this.props.dispatch(
                        getUrlPushWrapper('student.referralComponent')
                    )
                }}>
              <LazyLoadImage src="dist/img/earning.png" style={{marginLeft: 10}}/>
              Earn
            </a>
          </span>
            ) : null} */}
                <span onClick={() => {
                    this.resetUserPrivateMessage()
                }}>
          <PrivateMessageIcon
              className={styles.action}
              count={this.state.noOfMessage}
              onItemClick={(item, tabProps) => {
              }}
              locale={{
                  emptyText: 'No Message',
                  clear: 'All'
              }}
              onClear={onNoticeClear}
              viewAll={showAllPrivateMessage}
              onPopupMessageVisibleChange={onMessageVisibleChange}
              loading={fetchingNotices}
              clearClose
              list={this.state.privateMessageData}
              title={'Messages'}
              name='privateMessage'
          />
        </span>
                <LatestUpdateIcon {...this.props} />
                <PromotionIcon/>
                <span onClick={() => {
                    this.resetUserNotification()
                }}>
          <NoticeIcon
              className={styles.action}
              count={this.state.noOfNotification}
              onItemClick={(item, tabProps) => {
                  this.changeReadState(item, tabProps)
              }}
              locale={{
                  emptyText: 'No notifications',
                  clear: 'All'
              }}
              onClear={onNoticeClear}
              viewAll={showAllNotice}
              onPopupVisibleChange={onNoticeVisibleChange}
              loading={fetchingNotices}
              clearClose
              list={this.state.notificationData}
              title={'Notifications'}
              name='notification'
          />
        </span>
                {currentUser.email ? (
                    <HeaderDropdown overlay={menu}>
                        <div className={`${styles.action} ${styles.account} admin-box`}>
                            <Avatar
                                size='small'
                                className={styles.avatar}
                                src={currentUser.logo ? currentUser.logo.url : blankAvatar}
                                alt='avatar'
                            />
                            <div className={`${styles.name} content`} style={{marginTop: 0}}>
                                <h5
                                    style={{
                                        textTransform: 'capitalize',
                                        color: '#212529'
                                    }}>
                                    {currentUser.name}{' '}
                                    {currentUser.userType ? (
                                        <span className={'displayName'}>
                                             ({this.getDisplayName(currentUser)})
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </h5>
                                {currentUser.companyName ? (
                                    <div>
                                        <small>{currentUser.companyName}</small>
                                    </div>
                                ) : null}

                                {currentUser.referCode ? (
                                    <small>Reference Code: {currentUser.referCode}</small>
                                ) : null}
                            </div>

                        </div>
                    </HeaderDropdown>
                ) : (
                    <Spin size='small' style={{marginLeft: 8, marginRight: 8}}/>
                )}
            </div>
        )
    }
}

const mapStateToProps = ({counter, global}) => ({
    reloadNotification: global.reloadNotification,
    reloadPrivateMessage: global.reloadPrivateMessage,
    socketData: global.socketData,
    currentUserRights: global.currentUserRights,
    unreadLatestUpdate: global.unreadLatestUpdate
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalHeaderRight)
